module.exports = __webpack_public_path__ + "static/media/legal_after.154bcdc9.png";